import type { WalletProvider } from '@dynamic-labs-sdk/client/core';

import type { EvmWalletProvider } from '../EvmWalletProvider.types';

/** @not-instrumented */
export const isEvmWalletProvider = (
  walletProvider: WalletProvider
): walletProvider is EvmWalletProvider => walletProvider.chain === 'EVM';
